import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogConfig } from '@angular/material/dialog';
import { MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS } from '@angular/material/progress-spinner';
import { MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MAT_PAGINATOR_DEFAULT_OPTIONS } from '@angular/material/paginator';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';

export const matConfig = [
  {
    provide: MAT_DIALOG_DEFAULT_OPTIONS,
    useValue: { ...new MatDialogConfig(), minWidth: '500px', width: '500px', disableClose: true }
  },
  { provide: MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS, useValue: { diameter: 40 } },
  { provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: { position: 'above' } },
  { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } },
  { provide: MAT_PAGINATOR_DEFAULT_OPTIONS, useValue: { pageSize: 10 } },
  {
    provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: {
      duration: 3000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: ['snack-bar']
    }
  }
];
